import './App.css';
import Navbar from '../src/components/Navbar';
import  '../src/components/Navbar.css'
import '../src/components/Query.css'
function App() {
  return (
   <>
 <Navbar title ='Weather App!'/>

   </>
   
  );
}

export default App;
